import React from "react";
import LoungeHeading from "../../../../components/LoungeHeading";
import PollModule from "../../../../modules/PollModule";

const StaticModule = ({page, body}) => {
  return (
    <div>
      <LoungeHeading title={page.data?.title}>
        <p className="text-gray-400 mb-8 text-left text-base lg:text-base md:text-sm dont-break-out">{page.data?.description}</p>
      </LoungeHeading>

      <div className="lounge-body">
        {body}
      </div>

      {page.data?.module?.type === 'PollModule' && <PollModule className="mt-3" module={page.data?.module} />}
    </div>
  )
}

export default StaticModule;
